export default __webpack_public_path__ + "static/media/proctor-webcam-flagged.8db48427.svg";